export default class Department {
  constructor(department) {
    this.id = department._id
    this.name = department.name
    this.slug = department.slug
    this.createdAt = department.createdAt
    this.updatedAt = department.updatedAt
  }
}
